module.exports = __webpack_public_path__ + "static/media/team-placeholder.f87101c7.webp";